<template>

<div >
  <YearSummarySearchSidebar :isSidebarActive="showSearchSidebar" @closeSidebar="closeSidebar"  :search="search"/>
        <vs-button type="border" icon-pack="feather" icon="icon-search" @click="toggleDataSidebar(true)">{{$t('Search')}}</vs-button>
<div class="vx-card "> 
    <Calendar :display-week-number="true" :data-source="courses" @year-changed="yearChanged" @mouse-on-day="mouseOnDay" @mouse-out-day="mouseOutDay"></Calendar>
</div>
</div>
</template>

<script>
import Calendar from 'v-year-calendar';
import axios from "@/axios.js"
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import 'tippy.js/themes/light-border.css';
import YearSummarySearchSidebar from './YearSummarySearchSidebar.vue'
import moduleCourseCategory from "@/store/settings/courseCategory/moduleCourseCategory.js";
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseAreaOfStudy from "@/store/settings/courseAreaOfStudy/moduleCourseAreaOfStudy.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";

export default {
  components: { 
    Calendar,
    YearSummarySearchSidebar
  },
  data(){
    return {
       courses:[],
       currentYear:0,
      search:{},
     showSearchSidebar: false,
    
    }
  },  
  methods:{
    
    toggleDataSidebar(val = false) {
      debugger
      this.showSearchSidebar = val;
    },
  closeSidebar(search) {
    debugger
    if(search)
    {
       this.getYearSummary();
    }
      
     this.showSearchSidebar = false;
    },
    getYearSummary ()  {
     axios.post("api/AnnualPlan/GetYearSummary", this.search)
        .then((response) => {
          this.courses = response.data.map(function (val){
              val.startDate = new Date(val.startDate);
              val.endDate = new Date(val.endDate);
              return val;
          });

        })
        .catch((error) => { throw error })
    },
    yearChanged: function(e) {
      this.search.Year=e.currentYear;
      this.getYearSummary(e.currentYear);
    },
     mouseOnDay: function(e) {
      if (e.events.length > 0) {
        var content = '';

        for (var i in e.events) {
          content += '<div class="event-tooltip-content">'
            + '<div class="event-name" style="color:' + e.events[i].color + '">' + e.events[i].name + '</div>'            
            + '</div>';
        }

        if (this.tooltip != null) {
          this.tooltip.destroy();
          this.tooltip = null;
        }

        this.tooltip = tippy(e.element, {
            placement: 'top',
            content: content,            
            theme: 'light-border',
            animation: 'shift-away',
            arrow: true
        });
        this.tooltip.show();
      }
    },
    mouseOutDay: function() {
      if (this.tooltip !== null) {
        this.tooltip.destroy();
        this.tooltip = null;
      }
    }

  }, 
  computed:
  {
 
  },
  created()
  {
     if (!moduleCourseCategory.isRegistered) {
      this.$store.registerModule("courseCategoryList", moduleCourseCategory);
      moduleCourseCategory.isRegistered = true;
    }
       if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
     if (!moduleCourseAreaOfStudy.isRegistered) {
      this.$store.registerModule("courseAreaOfStudyList", moduleCourseAreaOfStudy);
      moduleCourseAreaOfStudy.isRegistered = true;
    }
     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    this.$store.dispatch("languageList/fetchDataListItems");
    this.$store.dispatch("courseAreaOfStudyList/fetchDataListItems");
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("courseCategoryList/fetchDataListItems");
  }
  
}
</script>